import { Vector3 } from "three";
import EditorPrototype from "./EditorPrototype.tsx";

/**
 * Cell = tilePosition in the 3D matrix that represents the map.
 */
export default class EditorCell {
  /**
   * Cell coordinates in the map
   * @type {Boolean}
   * @private
   */
  private readonly _coordinates: Vector3;

  /**
   * Collasped cell prototype
   * @private
   */
  private _prototype: EditorPrototype | null = null;

  private _editable: boolean = true;

  constructor(coordinates: Vector3) {
    this._coordinates = coordinates;
  }

  //// GETTERS

  get coordinates(): Vector3 {
    return this._coordinates;
  }

  get prototype(): EditorPrototype | null {
    return this._prototype;
  }

  get editable(): boolean {
    return this._editable;
  }

  //// SETTERS

  set prototype(prototype: EditorPrototype | null) {
    this._prototype = prototype;
  }

  set editable(editable: boolean) {
    this._editable = editable;
  }
}
